var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"loading",class:{ 'loading--visible': _vm.isLoading }},[_c('hollow-dots-spinner',{attrs:{"animation-duration":2000,"dot-size":20,"dots-num":3,"color":'#0AB783'}})],1),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__fadeIn animate__slow"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }